import Vue from 'vue'
import VueAxios from 'vue-axios'

import axios from './axios'
import configureInterceptors from './interceptors'

// Configure our custom interceptors.
configureInterceptors()

Vue.use(VueAxios, axios)

export default axios
